import React, { useEffect, useState } from "react";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import { baseURL, getBannersList } from "../../../networkCalls";
import Image from "react-image-webp";
import { isWebpSupported } from "react-image-webp/dist/utils";
const MainHIValueSlider = ({ bannerData, loading }) => {
  console.log('===== start log =======>');
  console.log(bannerData);
  console.log('<==== end   =======');
  const state = {
    responsive: {
      0: {
        items: 1,
      },
      450: {
        items: 1,
      },
      600: {
        items: 1,
      },
      1000: {
        items: 1,
      },
    },
  };
  // const [loading, setLoading] = useState(false);
  // const [bannerData, setBannerData] = useState([]);
  // const pullBannersList = () => {
  //   var data = new FormData();
  //   setLoading(true);
  //   getBannersList(data).then((res) => {
  //     setLoading(false);
  //     //console.log('data banner', res.data)
  //     switch (res.data.status) {
  //       case 1:
  //         setBannerData(res?.data?.bannerList);
  //         //setErrMessage('');
  //         return true;
  //       case 0:
  //         //setErrMessage(res.data.msz);
  //         break;
  //       default:
  //         return;
  //     }
  //   });
  // };

  // useEffect(() => {
  //   pullBannersList();
  // }, []);

  return (
    <div className="hivalueplusslider">
      {!loading ? (
        <>
          {" "}
          {bannerData.length > 1 ? <OwlCarousel
            className="owl-theme with-nav-bottom-center home-banner custom-carousel blue-nav"
            loop={true}
            animateIn="fadeIn"
            animateOut="fadeOut"
            autoplaySpeed={2000}
            autoplay={true}
            margin={25}
            items={1}
            nav={true}
            dots={false}

            responsive={state.responsive}
          >
            {bannerData &&
              bannerData?.length > 0 &&
              bannerData?.map((itemin, key) => (
                <div className="d-block" key={key}>
                  <div className="makehand">
                    <div className="icon-box text-center">
                      <div className="icon iconSize64 m-auto">
                        {itemin?.url != "" ? (
                          <>
                            <a href={itemin?.url}>
                              <img src={itemin?.banner} alt="" />
                            </a>
                          </>
                        ) : (
                          <>
                            <img src={itemin?.banner} alt="" />
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
          </OwlCarousel> : <img src={bannerData[0]?.banner} className="w-100 " alt="" />}
        </>
      ) : (
        <></>
      )}
    </div>
  );
};

export default React.memo(MainHIValueSlider);
